import { createFileRoute } from '@tanstack/react-router';
import { MeetingTemplateEditorPage } from '@/components/meeting-templates/MeetingTemplateEditorPage.tsx';
import { useRecordOrganisation } from '@/lib/recordOrganisation.ts';

export const Route = createFileRoute(
  '/_app/meeting-templates/organisations/$organisationId/$id',
)({
  staticData: { orgScope: 'record', orgScopeList: '/meeting-templates' },
  component: OrganisationTemplateRoute,
});

function OrganisationTemplateRoute() {
  const { organisationId, id } = Route.useParams();
  useRecordOrganisation(organisationId);
  return (
    <MeetingTemplateEditorPage
      scope='organisation'
      organisationId={organisationId}
      templateId={id}
    />
  );
}
